import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ListGroup,
  ListGroupItem,
  Input,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import moment from "moment";

import DatePickerComp from "../../component/DatePicker/DatePicker";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import referralAction from "../../redux/referral/action";
import PageHead from "../../component/pageHead/PageHead";
import api from "../../config/api";
import CustomButton from "../../component/CustomButton/CustomButton";
import { isNetworkRequestFailedError } from "../../config/helpers";

class NewReferral extends Component {
  state = {
    modal: false,
    isLoading: false,
    allStates: [],
    allLGA: [],
  };

  componentDidMount() {
    const { terms, allBanks, stateOfOrigin } = this.props;

    if (!terms) {
      this.fetchTerms();
    }

    if (!allBanks.length) {
      this.getAllBanks();
    }

    if (stateOfOrigin) {
      this.getLGA(stateOfOrigin);
    }

    this.getStates();
    this.getMyBank();
  }

  getStates = async () => {
    const { setAlertMessage, user } = this.props;

    try {
      const response = await api.fetchState({ countryCode: "NG" }, user.token);
      this.setState({ allStates: response.data.result });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.getStates : null,
      });
    }
  };

  getLGA = async (stateCode) => {
    const { setAlertMessage, user } = this.props;

    try {
      const response = await api.fetchLGA({ stateCode }, user.token);

      this.setState({ allLGA: response.data.result });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.getLGA(stateCode)
          : null,
      });
    }
  };

  getAllBanks = async () => {
    const { setAllBanks, setAlertMessage } = this.props;

    try {
      const response = await api.getAllBanks();
      setAllBanks(response.data.result);
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.getAllBanks : null,
      });
    }
  };

  getMyBank = async () => {
    const { setReferralInput, setAlertMessage, user } = this.props;

    if (user) {
      try {
        const response = await api.getBankDetails(
          { userName: user.User.UserName },
          user.token
        );

        const data = response.data.result;

        if (data) {
          setReferralInput({
            bankName: data.bankName,
            accountName: data.accountName,
            accountNumber: data.accountNumber,
          });
        }
      } catch (e) {
        setAlertMessage({
          type: "error",
          message: e.message,
          onTryAgain: isNetworkRequestFailedError(e) ? this.getMyBank : null,
        });
      }
    }
  };

  fetchTerms = async () => {
    const { setTermsAndCondition, setAlertMessage } = this.props;

    try {
      const response = await api.getTermsAndCondition();
      const data = response.data.PrivacyClause.replace(/\n/g, "<br />");

      setTermsAndCondition(data);
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchTerms : null,
      });
    }
  };

  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  handleTextChange = (e) => {
    const { setReferralInput } = this.props;

    if (e.target.name === "stateOfOrigin") {
      this.getLGA(e.target.value);
    }

    setReferralInput({ [e.target.name]: e.target.value });
  };

  createReferral = async () => {
    const { setAlertMessage, user } = this.props;
    const {
      accountName,
      accountNumber,
      bankName,
      firstName,
      surname,
      otherNames,
      phone,
      dateOfBirth,
      email,
      lgaCode,
      stateOfOrigin,
      nin,
    } = this.props;

    try {
      const isValid = this.validate();

      if (!isValid) throw new Error("Please Fill all mandatory fields");

      this.setState({ isLoading: true });

      const payload = {
        BankDetails: {
          id: 0,
          accountName,
          accountNumber,
          bankName,
          refereeUsername: user.User.Username,
        },
        Referral: {
          firstName,
          surname,
          otherNames,
          email,
          phone,
          nin,
          dateOfBirth,
          stateOfOrigin,
          lgaCode,
        },
      };

      await api.createReferral(payload, user.token);
      this.clearData();
      setAlertMessage({ type: "success", message: "successful" });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.createReferral : null,
      });
    }

    this.setState({ isLoading: false });
  };

  clearData = () => {
    const { setReferralInput } = this.props;
    const payload = {
      firstName: "",
      surname: "",
      otherNames: "",
      email: "",
      phone: "",
      nin: "",
      dateOfBirth: "",
      stateOfOrigin: "",
      lgaCode: "",
    };

    setReferralInput(payload);
  };

  validate = () => {
    const {
      bankName,
      accountNumber,
      accountName,
      firstName,
      surname,
      phone,
      email,
      stateOfOrigin,
      lgaCode,
    } = this.props;

    let isValidated = true,
      bankNameError,
      accountNumberError,
      accountNameError,
      firstNameError,
      surnameError,
      phoneError,
      stateOfOriginError,
      lgaCodeError;

    if (!bankName) {
      bankNameError = "This field is required";
      isValidated = false;
    }
    if (!accountName) {
      accountNameError = "This field is required";
      isValidated = false;
    }
    if (!accountNumber) {
      accountNumberError = "This field is required";
      isValidated = false;
    }
    if (!firstName) {
      firstNameError = "This field is required";
      isValidated = false;
    }
    if (!surname) {
      surnameError = "This field is required";
      isValidated = false;
    }

    if (!phone) {
      phoneError = "This field is required";
      isValidated = false;
    }

    if (!email) {
      if (!stateOfOrigin) {
        stateOfOriginError = "This field is required, if email is not provided";
        isValidated = false;
      }
      if (!lgaCode) {
        lgaCodeError = "This field is required, if email is not provided";
        isValidated = false;
      }
    }

    this.setState({
      bankNameError,
      accountNumberError,
      accountNameError,
      firstNameError,
      surnameError,
      phoneError,
      stateOfOriginError,
      lgaCodeError,
    });

    return isValidated;
  };

  render() {
    const { isLoading } = this.state;
    const {
      terms,
      bankName,
      accountNumber,
      accountName,
      firstName,
      surname,
      otherNames,
      phone,
      email,
      nin,
      dateOfBirth,
      stateOfOrigin,
      lgaCode,
      allBanks = [],
    } = this.props;

    const {
      bankNameError,
      accountNameError,
      accountNumberError,
      firstNameError,
      surnameError,
      phoneError,
      lgaCodeError,
      allStates,
      stateOfOriginError,
      allLGA,
    } = this.state;

    return (
      <div className="pb-3">
        <PageHead
          title="PLEASE PROVIDE YOUR BANK DETAILS FOR THE PURPOSE OF REWARD REDEMPTION"
          containerStyles={{ width: "100%" }}
        />
        <ListGroup className="my-3">
          <ReferralInput
            errorMessage={bankNameError}
            fieldName="Bank Name"
            name="bankName"
            value={bankName}
            type="select"
            options={allBanks}
            optionValue="DESCRIPTION"
            optionKey="DESCRIPTION"
            placeholder="Select your bank"
            containerClasses="rounded-top"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            errorMessage={accountNumberError}
            fieldName="Account Number"
            name="accountNumber"
            value={accountNumber}
            containerClasses="border-top-0"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            errorMessage={accountNameError}
            fieldName="Account Name"
            name="accountName"
            value={accountName}
            containerClasses="border-top-0"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
        </ListGroup>
        <PageHead
          title="PLEASE PROVIDE PROSPECT DETAILS"
          containerStyles={{ width: "100%" }}
        />
        <ListGroup className="my-3">
          <ReferralInput
            errorMessage={firstNameError}
            fieldName="First Name"
            name="firstName"
            value={firstName}
            containerClasses="rounded-top"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            errorMessage={surnameError}
            fieldName="Surname"
            name="surname"
            value={surname}
            containerClasses="border-top-0"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            fieldName="Other Names"
            name="otherNames"
            value={otherNames}
            containerClasses="border-top-0"
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            errorMessage={phoneError}
            fieldName="Phone Number (Mobile)"
            name="phone"
            value={phone}
            containerClasses="border-top-0"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            fieldName="Email"
            name="email"
            value={email}
            containerClasses="border-top-0"
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            fieldName="National Identity Number (NIN)"
            name="nin"
            value={nin}
            containerClasses="border-top-0"
            handleChange={this.handleTextChange}
          />
          <ReferralInput
            fieldName="Date of Birth"
            name="dateOfBirth"
            type="date"
            value={dateOfBirth}
            containerClasses="border-top-0"
            handleChange={this.handleTextChange}
          />
          {/* <ReferralInput
            fieldName="State of Origin"
            name="stateOfOrigin"
            value={stateOfOrigin}
            errorMessage={stateOfOriginError}
            containerClasses="border-top-0"
            isMandatory={true}
            handleChange={this.handleTextChange}
          /> */}
          <ReferralInput
            errorMessage={stateOfOriginError}
            fieldName="State of Origin"
            name="stateOfOrigin"
            value={stateOfOrigin}
            type="select"
            options={allStates}
            optionValue="stateName"
            optionKey="stateCode"
            placeholder="Select your State"
            containerClasses="rounded-top"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
          {/* <ReferralInput
            fieldName="LGA of Origin"
            name="lgaCode"
            value={lgaCode}
            errorMessage={lgaCodeError}
            containerClasses="border-top-0"
            isMandatory={true}
            handleChange={this.handleTextChange}
          /> */}
          <ReferralInput
            errorMessage={lgaCodeError}
            fieldName="LGA of Origin"
            name="lgaCode"
            value={lgaCode}
            type="select"
            options={allLGA}
            optionValue="lgaName"
            optionKey="lgaCode"
            placeholder="Select your LGA"
            containerClasses="rounded-top"
            isMandatory={true}
            handleChange={this.handleTextChange}
          />
        </ListGroup>
        <Row className="justify-content-center">
          <Col sm={6} md={4} className="my-1 text-center">
            <Button onClick={this.toggle} className="referral-btn px-0">
              Terms & Conditions
            </Button>
          </Col>
          <Col sm={6} md={4} xl={2} className="my-1">
            <CustomButton
              onClick={this.createReferral}
              buttonClasses="no-margin w-100"
              buttonText="Submit"
            />
          </Col>
        </Row>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className="mx-auto my-3 referral-modal"
        >
          <ModalHeader className="align-items-center py-0" toggle={this.toggle}>
            Terms & Conditions
          </ModalHeader>
          <ModalBody style={{ overflow: "auto", height: "85vh" }}>
            {terms && <span dangerouslySetInnerHTML={{ __html: terms }} />}
          </ModalBody>
        </Modal>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.referral.newReferral,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setTermsAndCondition: referralAction.setTermsAndCondition,
  setReferralInput: referralAction.setReferralInput,
  setAlertMessage: authAction.setAlertMessage,
  setAllBanks: referralAction.setAllBanks,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewReferral);

const ReferralInput = (props) => {
  const containerClasses = props.containerClasses || "";

  return (
    <ListGroupItem
      className={`d-flex align-items-center py-2 px-3 ${containerClasses}`}
    >
      <Row className="flex-grow-1 align-items-center">
        <Col sm={6} className="px-0">
          <label
            for={props.name}
            className="referral-field small"
            style={props.errorMessage && { color: "red" }}
          >
            {props.fieldName}
            {props.isMandatory && (
              <span className="text-danger referral-mandatory-sign">*</span>
            )}
          </label>
        </Col>
        <Col sm={6} className="px-0">
          {(props.type === "text" ||
            props.type === "email" ||
            props.type === "password" ||
            props.type === "number" ||
            props.type === "phone" ||
            !props.type) && (
            <Input
              className="referral-input font-weight-bold small"
              type={props.type}
              id={props.name}
              name={props.name}
              value={props.value}
              onChange={props.handleChange}
            />
          )}

          {props.type === "select" && (
            <Input
              className="referral-input font-weight-bold small"
              type="select"
              id={props.name}
              name={props.name}
              value={props.value}
              onChange={props.handleChange}
            >
              <option value="" disabled>
                {props.placeholder}
              </option>
              {props.options.map((item) => (
                <option
                  key={Math.random().toString()}
                  value={item[props.optionKey]}
                >
                  {item[props.optionValue]}
                </option>
              ))}
            </Input>
          )}

          {props.type === "date" && (
            <DatePickerComp
              value={props.value}
              maxDate={new Date(moment().subtract(1, "day"))}
              onChange={(e) => {
                const payload = {
                  target: {
                    name: props.name,
                    value: moment(e).format("YYYY-MM-DD"),
                  },
                };

                if (props.handleChange) {
                  props.handleChange(payload);
                }
              }}
              containerStyles={{ width: "100%" }}
              inputClasses="referral-date-picker-input"
            />
            // <Input
            //   type="date"
            //   value={props.value}
            //   name={props.name}
            //   onChange={props.handleChange}
            //   bsSize="sm"
            // />
          )}
        </Col>
      </Row>
    </ListGroupItem>
  );
};
